import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 572px;
`;
